module.exports = __webpack_public_path__ + "img/fuli_en_ID_img1.358d0807.png";